export default __webpack_public_path__ + "static/media/towerabnew.19251a02.png";